import DiscountCodes from 'pages/my/discount-codes';

export default DiscountCodes;
